/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SourceAwsOrganizationalUnit } from '../models/SourceAwsOrganizationalUnit';

export class ListSourceAwsOrganizationalUnitsResponse {
  /**
  * List of AWS organizational units.
  */
  'organizationalUnits': Array<SourceAwsOrganizationalUnit>;
  /**
  * Cursor that points to the first record of the next page of results. Pass this value in the next request. 
  */
  'nextToken'?: string;
  /**
  * Total number of AWS organizational units that matched the filter options.
  */
  'totalCount': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "organizationalUnits",
      "baseName": "organizationalUnits",
      "type": "Array<SourceAwsOrganizationalUnit>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListSourceAwsOrganizationalUnitsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

